import React from 'react';
import theme from './ProjectList.module.scss';
import { getProjectHeaderImageThumbnailUrl } from '@/services/projects';
import { Project } from '@/types';
import { faCopy } from '@fortawesome/pro-light-svg-icons';
import { useGetActiveProfile } from '@/utils/hooks';
import { Button } from '@/components/Buttons';
import { NotificationBadge, ProfileFeatureToggleFlags, ProjectFeatureToggleFlags, Thumbnail, useProfileHasFeatureToggle } from '@ygtechnologies/bygr-frontend-component-library';

interface ProjectTileProps {
    project: Project;
    numberOfTasks?: number | null;
    onCopyClicked: () => void;
}

const ProjectTile: React.FC<ProjectTileProps> = ({ project, numberOfTasks, onCopyClicked }) => {
    const onCopy = (e) => {
        e.preventDefault();
        onCopyClicked();
    };
    const profile = useGetActiveProfile();
    const showCopyProject = useProfileHasFeatureToggle(ProfileFeatureToggleFlags.CopyProject);
    return (
        <>
            <div className={theme.project}>
                <div className={theme.projectImage}>
                    <Thumbnail style={{ height: '100%' }} src={getProjectHeaderImageThumbnailUrl(project.id)} />
                </div>

                <div className={theme.content}>
                    <h5 className={theme.projectTitle}>{project.name}</h5>
                    <div className={theme.projectOwner}>{project.sellerProfileName}</div>
                </div>
                {showCopyProject && <Button color="text" icon={faCopy} onClick={onCopy} className={theme.icon} />}
            </div>
            <NotificationBadge size="large" className={theme.notificationBadge} value={numberOfTasks || 0} />
        </>
    );
};

export default ProjectTile;
